import React from 'react'
import { createColumn } from '../../../../utils/tableColumnHelpers'

export const makeCalculationsRowsOtherCriteria = (treatmentData) => {
  const rows = []

  // Process ecological integrity data
  if (treatmentData.ecologicalIntegrity && Array.isArray(treatmentData.ecologicalIntegrity)) {
    treatmentData.ecologicalIntegrity.forEach(item => {
      rows.push({
        criteriaAssessed: 'Ecological integrity',
        year: item.year,
        kbaCriteria: item.ecologicalIntegrity ? 'C' : '-'
      })
    })
  }

  // Process irreplaceability data
  if (treatmentData.irreplaceability && Array.isArray(treatmentData.irreplaceability)) {
    treatmentData.irreplaceability.forEach(item => {
      rows.push({
        criteriaAssessed: 'Irreplaceability',
        year: item.year,
        kbaCriteria: item.irreplaceability ? 'E' : '-'
      })
    })
  }

  return rows
}

export const makeCalculationsColumnsOtherCriteria = () => {
  return [
    createColumn({
      id: 'criteriaAssessed',
      headerId: 'criteriaAssessed',
      accessorKey: 'criteriaAssessed'
    }),
    createColumn({
      id: 'year',
      headerId: 'year',
      accessorKey: 'year'
    }),
    createColumn({
      id: 'kbaCriteria',
      headerId: 'kbaCriteria',
      accessorKey: 'kbaCriteria',
      style: {
        width: '10%'
      }
    })
  ]
}